module.exports = __webpack_public_path__ + "static/hut-audio-69faee76df2824c65b4268591a780054.mp3";